import { Button } from '@mui/material';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from '../../../../../utils/queryKeys';
import {
  findMatchingApiTag,
  getNextTagDisplayOrder,
  mapApiTagToMealTag,
} from '../../../../../utils/mealTagUtils';
import { createTag } from '../../../tag_management/TagManagementApi';
import TagManagementDialog from '../../../tag_management/TagManagementDialog';

const AddNewTagDialog = ({ availableTags = [], onTagCreated }) => {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);

  const createTagMutation = useMutation(createTag, {
    onSuccess: async (response, payload) => {
      await queryClient.invalidateQueries(queryKeys.getAllTagsData);

      const createdTag = mapApiTagToMealTag(response?.data ?? payload);
      onTagCreated?.(createdTag);
      toast.success('Tag created successfully');
      setOpen(false);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message ?? 'Unable to create tag');
    },
  });

  const handleSubmit = async (payload) => {
    const matchingTag = findMatchingApiTag(availableTags, payload);

    if (matchingTag) {
      onTagCreated?.(mapApiTagToMealTag(matchingTag));
      toast.success('Existing tag assigned to the meal');
      setOpen(false);
      return;
    }

    await createTagMutation.mutateAsync(payload);
  };

  return (
    <>
      <Button variant='contained' onClick={() => setOpen(true)}>
        Add new tag
      </Button>
      <TagManagementDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
        defaultDisplayOrder={getNextTagDisplayOrder(availableTags)}
        isSubmitting={createTagMutation.isLoading}
      />
    </>
  );
};

export default AddNewTagDialog;
